<template>
  <v-form fast-fail class="edit-user" v-click-outside="outsideCancelAction">
    <h2 class="title mb-2">{{ $t("ticketBuyerTypes.editModal.title") }}</h2>
    <v-text-field
      v-model="userData.name"
      :label="$t('ticketBuyerTypes.editModal.input')"
    ></v-text-field>

    <div class="btn-row mt-6">
      <v-btn @click="cancelAction">
        {{ $t("ticketBuyerTypes.editModal.cancel") }}
      </v-btn>
      <v-btn v-if="!isCreate" class="mb-2" @click="userDelete" color="red">
        {{ $t("ticketBuyerTypes.editModal.delete") }}
      </v-btn>
      <v-btn :disabled="!visibleButton" color="primary" @click="saveData">
        {{ $t("ticketBuyerTypes.editModal.save") }}
      </v-btn>
    </div>
  </v-form>
</template>

<script>
import { mapActions } from "vuex";

export default {
  name: "EditWebshopUserTypeModal",
  props: {
    user: {
      type: Object,
      required: false,
    },
  },
  data() {
    return {
      userData: {
        name: "",
      },
    };
  },
  mounted() {
    this.getUserData();
  },
  methods: {
    ...mapActions({}),
    getUserData() {
      this.userData.name = this.user.title;
      this.userData.id = this.user.id;
    },
    cancelAction() {
      if (document.activeElement.tagName != "INPUT") {
        this.emitter.emit("closeModal");
      }
    },
    outsideCancelAction(event) {
      const clickedElement = event.target;
      const classList = clickedElement.classList;

      if (classList.contains("v-overlay__scrim")) {
        this.cancelAction();
      }
    },
    saveData() {
      const userType = {
        name: this.userData.name.trimStart(),
        id: this.userData.id,
      };
      this.$emit("saveUser", userType);
      this.emitter.emit("closeModal");
    },
    userDelete() {
      const userType = {
        title: this.$t("ticketBuyerTypes.confirmModal.title"),
        subTitle: this.$t("ticketBuyerTypes.confirmModal.subTitle"),
        userId: this.userData.id,
      };
      this.emitter.emit("showConfirmModal", userType);
    },
  },
  computed: {
    visibleButton() {
      return this.userData.name.trim().length > 0;
    },
  },
};
</script>

<style lang="scss" scoped>
.edit-user {
  min-width: 400px;
  padding: 24px;
  @media (max-width: 520px) {
    min-width: 300px;
    padding: 12px;
  }
  .btn-row {
    display: flex;
    justify-content: space-between;
    @media (max-width: 520px) {
      flex-direction: column;
      gap: 12px;
    }
  }
}
</style>
